// sb-search-storage
sb.SearchStorage = class extends u.Storage {
    createdCallback() {
        this.isArchive = this.getAttribute('archive') === 'true';
    }

    attachedCallback() {
        super.attachedCallback();

        this._lastQuery = '';
        this.isRefreshDisabled = false;
        this.offset = 0;

        this.$set('results', []);
        this.$set('viewType', 'simple');

        this.$listen('filters', this.$changeFilter.bind(this));
        this.$listen('search', this.$changeFilter.bind(this));
        this.$listen('order', this.$changeFilter.bind(this));

        window.addEventListener('hashchange', this.$parseURL.bind(this));
        sb.SearchStorage.instances.push(this);
    }

    $callApi() {
        if (!this.isRefreshDisabled) {
            const queries = this.$buildQuery();
            this._lastQuery = queries.queryString;
            const xhr = new XMLHttpRequest();
            xhr.open('GET', `/api/v0/apps/?${queries.queryString}`);
            xhr.onload = () => {
                if (xhr.readyState === 4 && queries.queryString === this._lastQuery) {
                    const result = JSON.parse(xhr.responseText);
                    this.$set('results', result);
                    this.$sendGoogleAnalytics(queries.loggedQueries, this.offset, result.total);
                    this.offset = result.last;
                }
            };
            xhr.send();
        }
    }

    $changeFilter() {
        if (!this.isRefreshDisabled) {
            this.offset = 0;
            this.$callApi();
            this.$buildUrl();
        }
    }

    $loadMore() {
        this.$callApi();
    }

    $disableRefresh() {
        this.isRefreshDisabled = true;
    }

    $enableRefresh() {
        this.isRefreshDisabled = false;
    }

    $sendGoogleAnalytics(queries, offset, total) {
        // Only send under certain circumstances...
        // offset === 0: this is the first search - not subsequent searches due to pagination
        // "search" in queries: user searched for a string. Don't send if they just used filters with no search string
        if (offset === 0 && "search" in queries) {
            // sort queries by key ("search", "products", etc) so it's organized properly in google analytics
            let sorted = [];
            for (let key in queries) {
                sorted[sorted.length] = key;
            }
            sorted.sort();

            // put the sorted queries into a human readable string
            let searchParams = [];
            for (let key in sorted) {
                searchParams.push(sorted[key] + '=' + queries[sorted[key]]);
            }
            const joined_params = searchParams.join(', ');
            _gaq.push(['_trackEvent', 'Search', 'apps', joined_params, total]);
        }
    }

    $parseURL() {
        /**
         * when a page is first loaded or the url changes, we must parse the URL to pre-fill the filters
         * based on the fragment
         *
         * TODO(bchoi): change the frag to browser history in the future
         */

        // this.$set() fires callapi. We want to fire callApi when we are all done loading the filters based on
        // the url fragments
        this.$disableRefresh();

        this.$clearFilters();

        const hashes = window.location.hash.split('/');
        for (let i = 1; i < hashes.length; i += 2) {
            let filterType = hashes[i],
                value = decodeURIComponent(hashes[i + 1]);
            // Escape value to prevent XSS
            value = value.replace(/&/g, '').replace(/</g, '').replace(/>/g, '').replace(/"/g, '').replace(/'/g, '').replace(/\//g, '');
            if (filterType && value) {
                if (filterType in this.$get('filters')) {
                    let values = value.split(',');
                    for (let value of values) {
                        this.$set('filters|' + filterType + '|' + value, true);
                    }
                } else {
                    this.$set(filterType, value, true);
                }
            }
        }
        this.$enableRefresh();
        this.offset = 0;
        this.$callApi();
    }

    $buildQuery() {
        let queries = [];
        let loggedQueries = {}; // for google analytics

        const search = this.$get('search');
        let order = this.$get('order');
        let options = {};

        options.relevance = document.getElementById('sortrelevance'); 
        options.latest = document.getElementById('sortlatest');
        options.popular = document.getElementById('sortpopular');

        queries.push(`offset=${this.offset}`);

        options.relevance.removeAttribute('selected');
        options.latest.removeAttribute('selected');
        options.popular.removeAttribute('selected');

        // if keyword search is in place, we need to take care of some logistics
        if (search) {
            // If there's a search, enable/show the relevance sort option
            options.relevance.disabled = false;
            options.relevance.classList.remove("u.hide@*");

            queries.push(`search=${search}`);
            loggedQueries['search'] = search.toLowerCase();

            // if no order is selected, go with relevance order by default
            if (!order) {
                queries.push('order=relevance');
                options.relevance.selected = true;
            } else {
                queries.push(`order=${order}`);
                options[order].selected = true;
            }
        } else {

            // If there's no search, disable/hide the relevance sort option
            // this won't hide it in all browsers, hence disabling too
            options.relevance.classList.add("u.hide@*"); 
            options.relevance.disabled = true;

            // if no order is selected, go with newest order by default
            if (!order) {
                queries.push('order=latest');
                options.latest.selected = true;
            } else {
                queries.push(`order=${order}`);
                options[order].selected = true;
            }
            if (this.isArchive) {
                options.latest.selected = false;
                options.popular.selected = true;
                queries.push('order=popular');
            }
        }

        if (this.isArchive) {
            queries.push('archive=true');
        }else{
            queries.push('archive=false');
        }

        const obj = this.$get('filters');
        for (let filter of Object.keys(obj)) {
            let filters = [];
            for (let item of Object.keys(obj[filter])) {
                if (obj[filter][item] === true) {
                    filters.push(item);
                }
            }
            if (filters.length > 0) {
                queries.push(`${filter}=${filters.join(',')}`)
                loggedQueries[filter] = filters.join(',');
            }
        }

        return {queryString:queries.join('&'), loggedQueries:loggedQueries};
    }

    $buildUrl() {
        let params = [];

        const order = this.$get('order');
        if(order) {
            params.push(`order/${order}`);
        }

        const search = this.$get('search');
        if (search) {
            // URL encode the search keywords
            const uriSearch = encodeURI(search);
            // put the search keywords into the URL
            params.push(`search/${uriSearch}`);
        }

        const obj = this.$get('filters');
        for (let filter of Object.keys(obj)) {
            let filters = [];
            for (let item of Object.keys(obj[filter])) {
                if (obj[filter][item] === true) {
                    filters.push(item);
                }
            }
            if (filters.length > 0) {
                params.push(`${filter}/${filters.join(',')}`)
            }
        }
        history.pushState(null, null, '#/' + params.join('/'));
    }
    
    $clearFilters() {
        this.$set('filters', {});
        this.$set('filters|product', {});
        this.$set('filters|category', {});
        this.$set('filters|technology', {});
        this.$set('filters|type', {});
        this.$set('filters|app_content', {});
        this.$set('filters|version', {});
        this.$set('filters|cim', {});
        this.$set('filters|status', {});
        this.$set('filters|author', {});
        this.$set('filters|archive', {});
        this.$set('filters|validation', {});
        this.$set('order', '');
        this.$set('search', '');
        this.$set('offset', 0);
    }
}

sb.SearchStorage.instances = [];
sb.SearchStorage.register('sb-search-storage');

// sb-search-toggle
u.SearchToggle = class extends u.BaseElement {
    attachedCallback() {
        const group = this.getAttribute('group');
        if (!u.SearchToggle.groups.hasOwnProperty(group)) {
            u.SearchToggle.groups[group] = [];
        }

        u.SearchToggle.groups[group].push(this);

        super.attachedCallback();
        this.addEventListener('click', () => {
            this.classList.toggle('open');
            for (let toggle of u.SearchToggle.groups[group]) {
                if (toggle !== this) {
                    toggle.classList.remove('open');
                }
            }
        });
    }
};
u.SearchToggle.groups = {};
u.SearchToggle.register('sb-search-toggle');


// sb-filter-count
(class extends u.Bind {
    $onChange(value) {
        
        let count = 0;
        for (let key of Object.keys(value)) {
            if (value[key]) {
                count++;
            }
        }

        if (count) {
            this.textContent = count;
            this.classList.add('show');
        } else {
            this.classList.remove('show');
        }
    }
}).register('sb-filter-count');

// sb-search-checkbox
(class extends u.ConsumerInput {
    attachedCallback() {
        super.attachedCallback();
        this.searchfield = this.getAttribute('searchfield');
        if (this.searchfield !== null) {
            this.searchfield = this.getAttribute('searchfield');
            this.parentPath = `filters|${this.searchfield}`;
        } else {
            this.parentPath = `filters|${this.name}`;
        }
        this.path = `${this.parentPath}|${this.value}`;

        this.$storage.$listen(this.parentPath, this.$onClear.bind(this));
        this.$storage.$listen(this.path, this.$onChange.bind(this));

        this.addEventListener('change', () => {
            this.$storage.$set(this.path, this.checked ? true : false);
        });
    }

    $onChange(value) {
        this.checked = value;
    }

    // when filters are being cleared, we need to make sure all of checkboxes get cleared too.
    $onClear(value) {
        if (Object.keys(value).length === 0) {
            this.checked = false;
        }
    }
}).register('sb-search-checkbox');

// sb-bind
u.SbBind = class extends u.Bind {
    attachedCallback() {
        super.attachedCallback();
        this.$key = this.getAttribute('bind-key');
    }
    $onChange(value) {
        super.$onChange(value[this.$key]);
    }
};
u.SbBind.register('sb-bind');


// sb-results
(class extends u.Bind {
    attachedCallback() {
        super.attachedCallback();
        this.$key = this.getAttribute('bind-key');
    }
    $onChange(value) {
        // message for no results returned
        const no_results = document.querySelector('p[is=sb-no-results]');
        // hide sort select if no results returned
        const sort_select = document.querySelector('select[is=order-select]');

        if (value[this.$key] > 0) {
            no_results.classList.add('u.hide@*');
            sort_select.classList.remove('u.hide@*');
            this.classList.remove('u.hide@*');
        } else {
            no_results.classList.remove('u.hide@*');
            sort_select.classList.add('u.hide@*');
            this.classList.add('u.hide@*');
        }
    }
}).register('sb-results');


// sb-search
(class extends u.ConsumerInput {
    attachedCallback() {
        super.attachedCallback();
        this.addEventListener('change', ()=> {
            if (this.value) {
                this.$storage.$set('search', this.value);
            } else {
                this.$storage.$set('search', '');
            }
        });
    }
}).register('sb-search-input');

(class extends u.ConsumerInput {
    attachedCallback() {
        super.attachedCallback();
        this.addEventListener('change', ()=> {
            if (this.value) {
                this.$storage.$set('search', this.value);
            } else {
                this.$storage.$set('search', '');
            }
        });
    }
}).register('sb-archive-search-input');

// order-select
(class extends u.ConsumerSelect {
    attachedCallback() {
        super.attachedCallback();

        this.path = `${this.name}`;

        this.$storage.$listen(this.path, this.$onChange.bind(this));

        this.addEventListener('change', ()=> {
            this.$storage.$set('order', this.value);
        });
    }

    $onChange(value) {
        this.value = value;
    }
}).register('order-select');

// toggle for details vs. simple view
sb.SearchViewToggle = class extends u.Consumer {
    attachedCallback() {
        super.attachedCallback();

        this.viewType = this.getAttribute('type');
        sb.SearchViewToggle.items.push(this);

        this.addEventListener('click', ()=> {
            this.$storage.$set('viewType', this.viewType);

            // update button colors
            for (let i = 0; i < sb.SearchViewToggle.items.length; i++) {
                if (sb.SearchViewToggle.items[i].getAttribute('type') === this.viewType) {
                    sb.SearchViewToggle.items[i].firstElementChild.classList.add('active');
                } else {
                    sb.SearchViewToggle.items[i].firstElementChild.classList.remove('active');
                }
            }
        });
    }
};
sb.SearchViewToggle.items = [];
sb.SearchViewToggle.register('sb-view-toggle');

sb.AppCard = class extends u.Consumer {
    attachedCallback() {
        super.attachedCallback();
        this.type = this.getAttribute('type');
        this.$storage.$listen('viewType', this.$onChange.bind(this))

        // toggle based on the initial state when being added
        this.$onChange(this.$storage.$get('viewType'));
    }

    $onChange(value) {
        if(this.type === value) {
            this.classList.remove("u.hide@*");
        } else {
            this.classList.add("u.hide@*");
        }
    }
};
sb.AppCard.register('sb-app-card');
sb.AppCard.appCardsDetailed = [];
sb.AppCard.appCardsSimple = [];

// sb-search-pill
u.SbSearchPill = class extends u.Bind {
    attachedCallback() {
        super.attachedCallback();

        // canonical to display name map filled by sb-search-pill-map
        this.map = {};
        this.name = this.getAttribute('name');
    }

    $name(value) {
        // if the mapping exists, use it otherwise return the value as is
        if (value in this.map) {
            return this.map[value];
        }
        return value;
    }

    $onChange(value) {
        this.innerHTML = '';

        if (!value || value === undefined || value.length === 0) {
            return;
        }

        const self = this;
        const filters = [];

        if (typeof(value) === 'object') {
            for (let filter of Object.keys(value)) {
                if (value[filter]) {
                    filters.push({
                        name: this.$name(filter),
                        path: self.bindTo + "|" + filter
                    });
                }
            }
        } else {
            filters.push({
                name: this.$name(value),
                path: self.bindTo
            });
        }

        for (let filter of filters) {
            const button = document.createElement('button');
            button.className = "u.btn u.item c-search-pill";
            button.addEventListener('click', ()=> {
                self.$onRemove(filter.path);
            });

            const nameSpan = document.createElement('span');
            nameSpan.innerHTML = `${this.name}: `;

            // name:
            button.appendChild(nameSpan);

            const span = document.createElement('span');
            span.innerHTML = filter.name;

            const remove = document.createElement('span');
            remove.className = 'remove';
            remove.innerHTML = "<svg class='u.icon:tiny sb.color:gray-dark c-search-pill__close'><use xlink:href='#close-x'/></svg>";

            button.appendChild(span);
            button.appendChild(remove);
            this.appendChild(button);
        }
    }

    $onRemove(path) {
        this.$storage.$unset(path);
    }
};
u.SbSearchPill.register('sb-search-pill');

// sb-search-pill-map
(class extends u.BaseElement {
    attachedCallback() {
        super.attachedCallback();
        this.parentNode.map[this.getAttribute('canonical_name')] = this.getAttribute('display_name');
    }
}).register('sb-search-pill-map');

// sb-search-results
(class extends u.Bind {
    createdCallback() {
        this.isArchive = this.getAttribute('archive') === 'true';
    }

    attachedCallback() {
        super.attachedCallback();
    }

    $onChange(value) {
        if (!value.apps.length) {
            this.classList.add('u.hide@*');
        } else {
            this.classList.remove('u.hide@*');

            const appCards = [];
            for (let app of value.apps) {

                // Create the detailed app card
                const appCardDetailed = document.createElement('sb-app-card');
                appCardDetailed.className = "u.item:1/1@* sb.app-card";
                appCardDetailed.setAttribute("type", "detailed");
                appCardDetailed.innerHTML = `
                        <a href="/app/${app.id}">
                            <div class="u.container:nowrap@* u.container:top@* u.container:pad-little">
                                <img class="c-search-icon u.item u.icon:xl" src="${app.icon}" style="background-color: ${app.bg_color};"/>
                                <div class="u.item:grow@*">
                                    <div class="u.container">
                                        <div class="u.item:1/1@*">
                                            <div class="u.container">
                                                <h6 class="u.item">${app.name}</h6>
                                                <div class="u.item:hspace-sm" data-tooltip="Splunk Cloud" style="display:${app.cloud_compatible_static ? 'block' : 'none' }">
                                                    <svg class="u.icon sb.icon:badge">
                                                        <use xlink:href="#splunk-cloud"/>
                                                    </svg>
                                                </div>
                                                <div class="u.item:hspace-sm" data-tooltip="Built by Splunk" style="display:${app.is_splunk_built ? 'block' : 'none' }">
                                                    <svg class="u.icon sb.icon:badge">
                                                        <use xlink:href="#splunk-built"/>
                                                    </svg>
                                                </div>
                                                <div class="u.item:hspace-sm" data-tooltip="Splunk Labs" style="display:${app.is_splunk_works ? 'block' : 'none' }">
                                                    <svg class="u.icon sb.icon:badge">
                                                        <use xlink:href="#splunk-labs"/>
                                                    </svg>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="u.item:1/1@*"><p class="sb.wrap sb.clamp:3x">${app.pitch}</p></div>
                                        <div class="u.item:1/1@*">
                                            <div class="u.container:nowrap@md-up u.container:vspace-xs@sm c-search-details-footer">
                                                <div class="u.item:1/1@sm">Released: ${app.published}</div>
                                                <div class="u.item u.hide@sm"> | </div>
                                                <div class="u.item:1/1@sm">Updated: ${app.updated}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </a>
                `;
                appCards.push(appCardDetailed);

                // Create the simple app card
                const appCardSimple = document.createElement('sb-app-card');
                if (this.isArchive) {
                    appCardSimple.className = "u.item:tall@* u.item:2/12@lg-up u.item:6/12@md-down sb.app-card";
                }else{
                    appCardSimple.className = "u.item:tall@* u.item:3/12@lg-up u.item:6/12@md-down sb.app-card";
                }
                appCardSimple.setAttribute("type", "simple");
                appCardSimple.innerHTML = `
                        <a href="/app/${app.id}">
                          <div class="u.container:pad-little">
                            <img class="u.item u.icon:xl" src="${app.icon}" style="background-color: ${app.bg_color};"/>
                            <div class="u.item:1/1@*">
                                <h6 class="sb.clamp:heading-2x">${app.name}</h6>
                            </div>
                            <div class="u.item:1/1@*">
                                <div class="u.container:repel@* u.container:middle@*">
                                    <div class="u.item">
                                        <div class="u.container">
                                            <div class="u.item:hspace-sm" data-tooltip="Splunk Cloud" style="display:${app.cloud_compatible_static ? 'block' : 'none' }">
                                                <svg class="u.icon sb.icon:badge">
                                                    <use xlink:href="#splunk-cloud"/>
                                                </svg>
                                            </div>
                                            <div class="u.item:hspace-sm" data-tooltip="Built by Splunk" style="display:${app.is_splunk_built ? 'block' : 'none' }">
                                                <svg class="u.icon sb.icon:badge">
                                                    <use xlink:href="#splunk-built"/>
                                                </svg>
                                            </div>
                                            <div class="u.item:hspace-sm" data-tooltip="Splunk Labs" style="display:${app.is_splunk_works ? 'block' : 'none' }">
                                                <svg class="u.icon sb.icon:badge">
                                                    <use xlink:href="#splunk-labs"/>
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                      </a>
                `;
                appCards.push(appCardSimple);
            }

            if (value.first === 1) {
                this.innerHTML = '';
            }

            for(let appCard of appCards) {
                this.appendChild(appCard);
            }
        }
    }
}).register('sb-search-results');

// sb-search-results
(class extends u.Consumer {
    attachedCallback() {
        super.attachedCallback();
        const button = this.querySelector('[class*="u.bt"]');
        button.addEventListener('click', this.clickfunc.bind(this));
        this.$storage.$listen('results', this.$onChange.bind(this));
    }

    clickfunc(evt) {
        evt.preventDefault();
        this.$storage.$loadMore();
    }

    $onChange(value) {
        if (value.last === value.total) {
            this.classList.add('u.hide@*');
            //click event is removed to prevent a bug from occuring
            //this.removeEventListener('click', this.clickfunc);
        } else {
            this.classList.remove('u.hide@*');
        }
    }

}).register('sb-search-loadmore');

// sb-search-feedback-container
(class extends u.Consumer {
    attachedCallback() {
        super.attachedCallback();
        this.$storage.$listen('results', this.$onChange.bind(this));
    }
    $onChange(value) {
        if (value.last !== value.total) {
            this.classList.add('u.hide@*');
        } else {
            this.classList.remove('u.hide@*');
        }
    }

}).register('sb-search-feedback-container');


// sb-search-suggestion
(class extends u.SbBind {
    attachedCallback() {
        super.attachedCallback();
        this.addEventListener('click', (evt)=> {
            evt.preventDefault();
            window.location = `/apps/#/search/${this.value}`;
        });
    }

    $onChange(value) {
        this.value = value[this.$key];
        if (this.value) {
            this.classList.remove('u.hide@*');
            this.textContent = `Show Results for "${this.value}" Instead`;
        } else {
            this.classList.add('u.hide@*');
            this.textContent = null;
        }
    }
}).register('sb-search-suggestion');

//search feedback form processing
(class extends u.ModalForm {
    attachedCallback() {
        super.attachedCallback();
        this.$findStorage();
    }

    $submit(event) {
        const xhr = new XMLHttpRequest();
        xhr.onreadystatechange = () => {
            if(xhr.readyState === 4) {
                if (xhr.status !== 200) {
                    this.$error("An error occurred. Please try again");
                } else {
                    this.$onSuccess();
                }
            }
        };

        this.elements.submitbtn.value = "Submitting...";

        xhr.open('POST', '/api/v0/searchfeedback/');
        xhr.setRequestHeader('X-CSRFToken', getCsrfToken());

        const formData = new FormData(this);
        formData.append('category', Object.keys(this.$storage.$get('filters|category')).join(', '));
        formData.append('search', this.$storage.$get('search'));
        formData.append('versions', Object.keys(this.$storage.$get('filters|version')).join(', '));
        formData.append('type', Object.keys(this.$storage.$get('filters|type')).join(', '));
        formData.append('cims', Object.keys(this.$storage.$get('filters|cim')).join(', '));
        formData.append('results', this.$storage.$get('results').total);

        xhr.send(formData);
    }

    $closeModal() {
        window.location.reload(false);
    }

    $findStorage() {
        // hacky but better than trying to use multi-inheritance hack
        this.$storage = null;

        let elem = this.parentElement;
        while (elem) {

            if (elem instanceof u.Storage) {
                this.$storage = elem;
            }
            elem = elem.parentElement;
        }
    }
}).register('sb-search-feedback');

window.addEventListener('WebComponentsReady', function (e) {
    for(let instance of sb.SearchStorage.instances) {
        instance.$parseURL();
    }
});
